import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-api-job-logs-page',
  templateUrl: './api-job-logs-page.component.html',
  styleUrl: './api-job-logs-page.component.scss',
})
export class ApiJobLogsPageComponent implements OnInit {
  tenantId?: string;

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.tenantId = this.authService.currentUser?.tenant_id;
  }
}
